import {
  QUERY_BUILDER_CLOSE_BRACKET,
  QUERY_BUILDER_OPEN_BRACKET,
  QueryBuilderBracketType,
} from '../../../../../../types';

export const getBracketLabel = (bracket: QueryBuilderBracketType): string =>
  bracket === 'OPEN'
    ? QUERY_BUILDER_OPEN_BRACKET
    : QUERY_BUILDER_CLOSE_BRACKET;
